import { breakpoint } from '@carvana/helios-layout';
import { background, border, brand, spacing, text } from '@carvana/helios-styles';
import { body } from '@carvana/helios-typography';
import styled from 'styled-components';

const Background = styled.div`
  width: 100%;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:before {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 240px;
    content: '';
    background-color: ${background.strong};

    ${breakpoint.sm`
      height: 270px;
    `}

    ${breakpoint.md`
      height: 528px;
    `}
  }
`;

const HeroContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;

  ${breakpoint.md`
    flex-direction: row;
    justify-content: space-between;
    width: 1056px;
  `}

  ${breakpoint.lg`
    padding: 0;
    width: 1056px;
  `}
`;

const HeadingWrapper = styled.div`
  box-sizing: border-box;
  padding: 0 32px;
  width: 100%;
  height: 176px;
  text-align: center;

  ${breakpoint.sm`
    height: 176px;
  `}

  ${breakpoint.md`
    padding: 0;
    height: 286px;
  `}
`;

const Heading = styled.h2<{ $isLongHeader?: boolean }>`
  ${brand.sm};
  text-transform: ${brand.sm.textCase};
  color: ${text.inverse};
  box-sizing: border-box;
  margin: 40px auto 20px;
  min-width: 327px;

  ${breakpoint.sm`
    margin: 40px 24px 20px;
    margin-top: 60px;
  `};

  ${breakpoint.md`
    ${brand.lg};
    text-align: left;
    margin: 148px 0 20px;

    ${props =>
      props.$isLongHeader &&
      `margin: 100px 0 20px;
    `};
  `};
`;

const SubTitle = styled.p`
  ${body.lg};
  box-sizing: border-box;
  color: ${text.inverse};
  margin: ${spacing.lg} auto;
  min-width: 327px;

  ${breakpoint.sm`
    margin: ${spacing.lg} 60px;
  `};

  ${breakpoint.md`
    ${body.xl};
    text-align: left;
    margin: ${spacing.lg} 0;
    max-width: 616px;
  `};

  ${breakpoint.lg`
    max-width: 616px;
  `};
`;

const CardWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  min-width: 327px;
  width: 100%;
  padding: 20px 24px;
  z-index: 10;

  ${breakpoint.sm`
    padding: 20px 30px;
    min-width: unset;
  `};

  ${breakpoint.md`
    justify-content: flex-end;
    margin: 0;
    padding: 0;
  `}
`;

const Card = styled.div`
  box-sizing: border-box;
  min-height: 274px;
  width: 100%;
  padding: 6px 16px;
  border: 1px solid ${border.weak};
  border-radius: 16px;
  background-color: ${background.default};

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;

  ${breakpoint.md`
    width: 516px;
    max-height: 286px;
    margin: 80px 0 72px 50px;   
  `}
`;

export { Background, Heading, SubTitle, HeroContainer, HeadingWrapper, CardWrapper, Card };
